export default {"src":"/_next/static/media/mobile-message.f1702f32.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};